import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { ProfessionalDataProps } from "src/models/professional.model";
import { PutPayloadProps } from "src/models/service.models";
import commonUtils from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function editProfessionalApproveReject(
  params: string,
  data: PutPayloadProps
) {
  return await apiCall.patch(
    API_URL.DENTAL_PROFESSIONAL.REJECT_APPROVE + params,
    data
  );
}
export async function getProfessionalUsers(params?: ProfessionalDataProps) {
  return await apiCall.get(API_URL.DENTAL_PROFESSIONAL.GET_PROFESSIONAL_USERS, {
    ...params,
  });
}
export async function getProfessionalUserAllData(params: string) {
  return await apiCall.get(
    API_URL.DENTAL_PROFESSIONAL.GET_USER_ALL_DATA + params
  );
}
export async function getReleaseContract() {
  return await apiCall.get(API_URL.DENTAL_PROFESSIONAL.GET_CONTRACT);
}

export async function updateDob(professionalId: string, data: { dob: string }) {
  return await apiCall.patch(
    API_URL.DENTAL_PROFESSIONAL.UPDATE_DOB + professionalId,
    data
  );
}

export async function updateMobile(
  userUuid: string,
  data: { phone_number: string }
) {
  return await apiCall.patch(
    API_URL.DENTAL_PROFESSIONAL.UPDATE_MOBILE + userUuid,
    data
  );
}

export async function updateSalutation(
  professionalId: string,
  data: { salutation: string }
) {
  const url = commonUtils.getUrlReplace(
    API_URL.DENTAL_PROFESSIONAL.UPDATE_SALUTATION,
    COMMON_CONSTANTS.PROFESSIONAL_UUID,
    professionalId
  );
  return await apiCall.patch(url, data);
}

export async function updateAdpId(
  professionalId: string,
  data: { adp_id: string }
) {
  return await apiCall.patch(
    API_URL.DENTAL_PROFESSIONAL.UPDATE_ADP + professionalId,
    data
  );
}
